export default getText => key =>
  ({
    home: getText('Home', 'TopBar'),
    schedule: getText('Appointments & Schedules', 'TopBar'),
    invite: getText('Invite for MIA (SMS/Mail)', 'TopBar'),
  }[key])
